<template>
    <div>
        <template v-if="vmStatus === 'loading'">
            <div class="sau-bx bx-pad text-center">
                <sau-spinner />
            </div>
        </template>
        <template v-else-if="vmStatus.toLowerCase() != 'busy'">
            <sau-service-status :service="service"></sau-service-status>

            <bw-usage :service="service" />
        </template>
        <template v-else>
            <div class="sau-bx bx-pad text-center">
                <div class="sau-status-box">
                    <div class="sau-i-circle md primary pt-1">
                        <i class="md white fal fa-spinner-third fa-spin"></i>
                    </div>
                    <h5 class="sau-para-m pt-2">Status: <span class="text-primary">Busy</span></h5>
                    <p v-for="(task, index) in tasks" :key="`${task.name}-${index}`" class="mb-0">{{ task.name }} - {{ task.percentComplete }}%</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import SauSpinner from '../../utilities/SauSpinner.vue';
import BwUsage from '@v1/service/BwUsage.vue';

export default {
    props:['service'],
    components: { SauSpinner, BwUsage },
    data() {
        return {
            vmStatus: 'loading',
            tasks: [],
            loading: false,
        }
    },
    mounted() {
        this.checkVmStatus();
    },
    methods: {
        checkVmStatus() {
            this.getDeviceStatus()
                .then((response) => {
                    this.vmStatus = _.get(response, 'data.data.status', '');
                    if(this.vmStatus.toLowerCase() === 'busy') {
                        this.tasks =  _.get(response, 'data.data.tasks', []);
                        setTimeout(() => {
                            this.checkVmStatus();
                        }, 5000);
                    } else {
                        this.tasks = [];
                    }
                });
        }
    }
}
</script>

<style>
</style>
